import {Component} from 'react';
import h from 'react-hyperscript';
import './Filters.scss';
import {footnote} from 'Components/Typography/Typography';
import {handleButtonKeyEvents} from 'Src/utils/utils';
import FilterItem from './FilterItem';

class Filters extends Component {
  constructor(props) {
    super(props);
    this.inactiveClasses = 'filter-item filter-item--all';
    this.activeClasses = `${this.inactiveClasses} active`;
    this.state = {
      filteredProducts: this.props.filteredProducts,
      classes: this.inactiveClasses,
    };
  }

  componentDidMount() {
    this.setFilteredProducts();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.filteredProducts !== this.props.filteredProducts) {
      this.setFilteredProducts();
    }
  }

  setFilteredProducts() {
    this.setState({
      filteredProducts: this.props.filteredProducts,
    }, () => {
      this.checkIfViewAll();
    });
  }

  setClasses(value) {
    this.setState({
      classes: value,
    });
  }

  checkIfViewAll() {
    const filteredIds = this.props.filteredProducts.map((product) => {
      return product.id;
    });

    const totalIds = this.props.totalFilters.map((product) => {
      return product.id;
    });

    if (totalIds.length === filteredIds.length) {
      this.setClasses(this.activeClasses);
    } else {
      this.setClasses(this.inactiveClasses);
    }
  }

  render() {
    const handleViewAll = this.props.handleViewAll;

    return (
      h('div', {
        className: 'filters flex flex--wrap',
      }, [
        h(footnote, {
          className: 'filter__title',
        }, this.props.title),

        h('div', {
          key: 'filter-view-all',
          tabIndex: 0,
          className: this.state.classes,
          onClick: handleViewAll,
          onKeyUp: (e) => handleButtonKeyEvents(e, handleViewAll),
        }, h(footnote, null, 'View all')),

        this.props.totalFilters.map((filter, i) => {
          return (
            h(FilterItem, {
              key: `${filter.title.toLowerCase().replace(' ', '-')}--filter`,
              index: i,
              filteredProducts: this.state.filteredProducts,
              id: filter.title.toLowerCase().replace(' ', '-'),
              title: filter.title,
              handleFilterClick: this.props.handleFilterClick,
              color: filter.color,
              inactiveClasses: 'filter-item',
              totalFilters: this.props.totalFilters,
            }, null)
          );
        }),

      ])
    );
  }
}

export default Filters;
